import React, { Suspense } from 'react';

const Notifications = React.lazy(() => import(/* webpackChunkName: "NotificationSettings" */ './NotificationsSettings'));

const DatastoreUserAdapter = React.lazy(() => import(/* webpackChunkName: "NotificationSettings" */ './data/DatastoreUserAdapter'));

export default class NotificationsLoader {
    constructor(config) {
        this.config = this._parseConfiguration(config);
    }

    getComponent() {
        const dataAdapter = this._getDataAdapter();
        const component = <Notifications {...this.config} userAdapter={dataAdapter} />;

        return <Suspense fallback={<div className="notifications__skeleton">Loading...</div>}>{component}</Suspense>;
    }

    _parseConfiguration(config) {
        return {
            ...config,
        };
    }

    _getDataAdapter() {
        const { datasource, datasourceUrl, datasourceJWT } = this.config;

        if (datasource === 'datastore') {
            const datastore = new Datastore({
                serviceURL: datasourceUrl,
                jwtURL: datasourceJWT,
            });

            return new DatastoreUserAdapter({ datastore });
        }

        return undefined;
    }
}
